import React from 'react';
import { useLang } from '@shootout-comps/i18n';

interface DivisionTabsProps {
  active: 'teams' | 'fixtures' | 'standings' | 'history';
  onSelect: (tab: 'teams' | 'fixtures' | 'standings' | 'history') => void;
}

// Small pill switcher shared between DivisionTeamsPage, DivisionFixturesPage,
// DivisionStandingsPage and SeasonHistoryPage — each page stays self-contained (own header/back
// button/data-fetching), this is just the shared bit of chrome that lets you flip between them.
export default function DivisionTabs({ active, onSelect }: DivisionTabsProps) {
  const { t } = useLang();
  const pill = (key: 'teams' | 'fixtures' | 'standings' | 'history', label: string) => (
    <button
      onClick={() => onSelect(key)}
      style={{
        background: active === key ? 'rgba(201,168,76,0.15)' : 'transparent',
        border: `1px solid ${active === key ? 'rgba(201,168,76,0.4)' : 'rgba(255,255,255,0.12)'}`,
        borderRadius: '20px', padding: '0.4rem 1rem', fontSize: '0.8rem', fontWeight: 600,
        color: active === key ? 'var(--gold)' : 'var(--chalk-dim)', cursor: 'pointer',
      }}
    >
      {label}
    </button>
  );

  return (
    <div style={{ display: 'flex', gap: '0.5rem', marginBottom: '1.25rem' }}>
      {pill('teams', t.divisionTabTeams)}
      {pill('fixtures', t.divisionTabFixtures)}
      {pill('standings', t.divisionTabStandings)}
      {pill('history', t.historyTabLabel)}
    </div>
  );
}
